export default {
  headerContent: {
    title: 'HDI Sigorta Zorunlu Trafik Sigortası Teklif Al',
    slogan: "Trafik Sigortası'nı işin uzmanına bırak.",
    btnTitle: 'TRAFİK SİGORTASI TEKLİFİ AL'
  },
  crossPageContent: {
    mainTitle: 'HDI Sigorta Zorunlu Trafik Sigortası',
    description: {
      title: 'HDI Sigorta Zorunlu Trafik Sigortası Nedir?  ',
      content: [
        'HDI Sigorta’nın zorunlu trafik sigortası ürününü alarak karayolunda kaza sonucu karşı tarafa veya 3. Şahıslara vereceğiniz hasarları poliçede belirlenmiş olan limitler kapsamında güvence altına alabilirsiniz.',
        'Trafik sigortası Türkiye sınırları içerisinde kullanılan her türlü motorlu araç sahibinin yaptırmak zorunda olduğu sigorta ürünüdür.'
      ]
    },
    subContent: {
      title: 'HDI Sigorta Zorunlu Trafik Sigortası Neleri Kapsar?',
      content: [
        {
          paragraph:
            'HDI Sigorta trafik sigortası sigortalının kazaya karışması durumunda karşı tarafın veya 3. Şahısların uğrayacağı maddi ve bedeni hasarları poliçede belirtilen limitlere kadar karşılar.',
          subList: null
        }
      ]
    }
  },
  getPrice: {
    mainTitle: 'Trafik Sigortası Teklifi Nasıl Alınır?',
    campaigns: [
      {
        id: 1,
        name: 'Trafik Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      },
      {
        id: 2,
        name: 'Trafik Sigortası',
        assurance: 'Standart Teminatlı',
        price: '+50 TL'
      },
      {
        id: 3,
        name: 'Trafik Sigortası',
        assurance: 'Zorunlu Teminatlı',
        price: '+50 TL'
      },
      {
        id: 4,
        name: 'Trafik Sigortası',
        assurance: 'Ek Teminatlı',
        price: '+50 TL'
      }
    ]
  },
  faqTitle: 'HDI Sigorta Trafik Sigortası Hakkında Merak Edilenler',
  faqTitleDesc: 'Her gün yayınlanan güvenilir bilgilere kolay erişim.',
  questions: []
}
